/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import { useState } from 'react';
import { useChat } from '@ai-sdk/react';
import { DefaultChatTransport } from 'ai';
import { Link } from 'react-router-dom';
import { getToken } from '../../utils/token';
import { config } from '../../config';
import './RedshiftChatPage.css';

export const RedshiftChatPage = () => {
  const [input, setInput] = useState('');
  const [expandedTools, setExpandedTools] = useState<Set<string>>(new Set());
  const [copiedToolId, setCopiedToolId] = useState<string | null>(null);
  const [mcpTools, setMcpTools] = useState<unknown>(null);
  const [showMcpTools, setShowMcpTools] = useState(false);
  const [loadingTools, setLoadingTools] = useState(false);

  const { messages, sendMessage, status, error } = useChat({
    transport: new DefaultChatTransport({
      api: `${config.ADMIN_API_URL}/api/admin/v2/agent/bedrock/redshift-mcp`,
      headers: () => ({
        Authorization: `Bearer ${getToken()}`,
      }),
    }),
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (input.trim() && status === 'ready') {
      const query = input.trim();
      sendMessage({ text: query });
      setInput('');
    }
  };

  const handleDiscoverTools = async () => {
    setLoadingTools(true);
    try {
      const response = await fetch(`${config.ADMIN_API_URL}/api/admin/v2/agent/bedrock/redshift-mcp/discover`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${getToken()}`,
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
      setMcpTools(data);
      setShowMcpTools(true);
      console.log('MCP Tools:', data);
    } catch (error) {
      console.error('Failed to discover MCP tools:', error);
      alert('Failed to discover MCP tools. Check console for details.');
    } finally {
      setLoadingTools(false);
    }
  };

  return (
    <>
      <div className="chat-container">
        <div className="chat-header">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <h1 className="text-2xl font-bold">Redshift Data Assistant</h1>
              <Link
                to="/chat"
                style={{
                  fontSize: '14px',
                  color: '#0066cc',
                  textDecoration: 'none',
                  padding: '4px 12px',
                  border: '1px solid #0066cc',
                  borderRadius: '4px',
                  transition: 'all 0.2s',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#0066cc';
                  e.currentTarget.style.color = 'white';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                  e.currentTarget.style.color = '#0066cc';
                }}
              >
                ← AI Chat
              </Link>
            </div>
            <button
              onClick={handleDiscoverTools}
              disabled={loadingTools}
              style={{
                padding: '8px 16px',
                fontSize: '14px',
                backgroundColor: '#28a745',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                cursor: loadingTools ? 'wait' : 'pointer',
                fontWeight: 500,
                opacity: loadingTools ? 0.7 : 1,
              }}
              type="button"
            >
              {loadingTools ? '🔍 Loading...' : '🔧 Show MCP Tools'}
            </button>
          </div>
          <p className="text-sm">
            I have access to the C2FO Redshift data warehouse. Ask me questions about your data and I&apos;ll query
            Redshift to find answers.
          </p>
        </div>

        {/* MCP Tools Display */}
        {showMcpTools && mcpTools && (
          <div
            style={{
              margin: '16px 0',
              padding: '16px',
              backgroundColor: '#f8f9fa',
              borderRadius: '8px',
              border: '1px solid #dee2e6',
            }}
          >
            <div
              style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}
            >
              <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 600 }}>
                📦 Available MCP Tools {mcpTools.success && `(${mcpTools.toolCount})`}
              </h3>
              <button
                onClick={() => setShowMcpTools(false)}
                style={{
                  padding: '4px 12px',
                  fontSize: '12px',
                  backgroundColor: '#6c757d',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                }}
                type="button"
              >
                Close
              </button>
            </div>
            {mcpTools.success ? (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                {mcpTools.tools.map(
                  (tool: { name: string; description?: string; inputSchema?: unknown }, index: number) => (
                    <div
                      key={index}
                      style={{
                        padding: '12px',
                        backgroundColor: 'white',
                        borderRadius: '6px',
                        border: '1px solid #dee2e6',
                      }}
                    >
                      <div style={{ fontWeight: 600, fontSize: '14px', marginBottom: '4px' }}>{tool.name}</div>
                      <div style={{ fontSize: '13px', color: '#666', marginBottom: '8px' }}>{tool.description}</div>
                      {tool.inputSchema && (
                        <details style={{ fontSize: '12px' }}>
                          <summary style={{ cursor: 'pointer', color: '#007bff', fontWeight: 500 }}>
                            View Input Schema
                          </summary>
                          <pre
                            style={{
                              marginTop: '8px',
                              padding: '8px',
                              backgroundColor: '#f8f9fa',
                              borderRadius: '4px',
                              overflow: 'auto',
                              fontSize: '11px',
                            }}
                          >
                            {JSON.stringify(tool.inputSchema, null, 2)}
                          </pre>
                        </details>
                      )}
                    </div>
                  ),
                )}
              </div>
            ) : (
              <div style={{ color: '#dc3545', fontSize: '14px' }}>
                ❌ Error: {mcpTools.error || 'Failed to load tools'}
                {mcpTools.response && (
                  <pre style={{ marginTop: '8px', fontSize: '11px', overflow: 'auto' }}>
                    {JSON.stringify(mcpTools.response, null, 2)}
                  </pre>
                )}
              </div>
            )}
          </div>
        )}

        <div className="chat-messages">
          {messages.length === 0 && (
            <div className="empty-state">
              <p>Start a conversation by typing a message below.</p>
              <p>
                Examples: &quot;How many active markets are there?&quot; or &quot;Show me the top 10 users by
                transaction volume&quot;
              </p>
            </div>
          )}
          {messages.map((message) => (
            <div key={message.id} className={`message message-${message.role}`}>
              <div className="message-role">
                {message.role === 'user' ? 'You' : 'Assistant'}
                {/* Display timing metadata if available */}
                {message.metadata && (message.metadata as { duration_ms?: number }).duration_ms && (
                  <span
                    className="message-timing"
                    style={{
                      marginLeft: '8px',
                      fontSize: '11px',
                      color: '#666',
                      fontWeight: 'normal',
                      backgroundColor: '#f0f0f0',
                      padding: '2px 6px',
                      borderRadius: '3px',
                    }}
                  >
                    ⚡ {((message.metadata as { duration_ms: number }).duration_ms / 1000).toFixed(2)}s
                  </span>
                )}
              </div>
              <div className="message-content">
                {message.parts.map(
                  (
                    part: {
                      type: string;
                      text?: string;
                      toolName?: string;
                      toolCallId?: string;
                      result?: unknown;
                      state?: string;
                      output?: unknown;
                      errorText?: string;
                    },
                    index,
                  ) => {
                    if (part.type === 'text') {
                      return <span key={index}>{part.text}</span>;
                    }

                    // Handle MCP dynamic tool calls
                    if (part.type === 'dynamic-tool') {
                      const toolId = `${message.id}-tool-${index}`;
                      const isExpanded = expandedTools.has(toolId);
                      const toggleTool = () => {
                        setExpandedTools((prev) => {
                          const next = new Set(prev);
                          if (next.has(toolId)) {
                            next.delete(toolId);
                          } else {
                            next.add(toolId);
                          }

                          return next;
                        });
                      };

                      // Extract tool info directly from the part
                      const toolName = part.toolName || 'Tool Call';
                      const input = part.input;
                      const output = part.output || part.result;
                      const state = part.state; // 'input-available', 'output-available', etc.

                      // Extract SQL query if available
                      const getSqlQuery = () => {
                        if (input && typeof input === 'object' && 'query' in input) {
                          return input.query as string;
                        }

                        return null;
                      };

                      const sqlQuery = getSqlQuery();

                      return (
                        <div key={index} className="tool-call">
                          <button type="button" className="tool-call-header" onClick={toggleTool}>
                            <div className="tool-call-title">
                              <svg
                                className="tool-icon"
                                width="14"
                                height="14"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              >
                                <circle cx="12" cy="12" r="3"></circle>
                                <path d="M12 1v6m0 6v6m9-9h-6m-6 0H3m15.364 6.364l-4.243-4.243m-4.242 0l-4.243 4.243m0-8.485l4.243 4.243m4.242 0l4.243-4.243"></path>
                              </svg>
                              <span className="tool-name">{toolName}</span>
                              <span
                                className={`tool-status ${
                                  state === 'output-available' ? 'status-completed' : 'status-running'
                                }`}
                              >
                                {state === 'output-available' ? 'Completed' : 'Running'}
                              </span>
                            </div>
                          </button>

                          {/* Always show SQL query for execute_sql_tool */}
                          {sqlQuery && (
                            <div
                              className="sql-preview"
                              style={{
                                marginTop: '8px',
                                padding: '12px',
                                backgroundColor: '#f8f9fa',
                                borderRadius: '4px',
                                border: '1px solid #e0e0e0',
                              }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  marginBottom: '8px',
                                }}
                              >
                                <span
                                  style={{
                                    fontSize: '11px',
                                    fontWeight: 600,
                                    color: '#666',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.5px',
                                  }}
                                >
                                  SQL Query
                                </span>
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    navigator.clipboard.writeText(sqlQuery);
                                    const toolId = `${message.id}-tool-${index}`;
                                    setCopiedToolId(toolId);
                                    setTimeout(() => setCopiedToolId(null), 2000);
                                  }}
                                  style={{
                                    padding: '4px 8px',
                                    fontSize: '11px',
                                    backgroundColor:
                                      copiedToolId === `${message.id}-tool-${index}` ? '#e8f5e9' : '#fff',
                                    border:
                                      copiedToolId === `${message.id}-tool-${index}`
                                        ? '1px solid #4caf50'
                                        : '1px solid #d0d0d0',
                                    borderRadius: '3px',
                                    cursor: 'pointer',
                                    color: copiedToolId === `${message.id}-tool-${index}` ? '#2e7d32' : '#333',
                                    transition: 'all 0.2s ease',
                                  }}
                                  type="button"
                                >
                                  {copiedToolId === `${message.id}-tool-${index}` ? '✓ Copied!' : '📋 Copy'}
                                </button>
                              </div>
                              <pre
                                style={{
                                  margin: 0,
                                  padding: '8px',
                                  backgroundColor: '#fff',
                                  borderRadius: '3px',
                                  fontSize: '13px',
                                  lineHeight: '1.5',
                                  overflowX: 'auto',
                                  fontFamily: 'Monaco, Consolas, "Courier New", monospace',
                                  color: '#2d3748',
                                }}
                              >
                                {sqlQuery}
                              </pre>
                            </div>
                          )}

                          {isExpanded && (
                            <div className="tool-call-content">
                              {input && Object.keys(input).length > 0 && (
                                <div className="tool-call-section">
                                  <div className="tool-call-label">PARAMETERS</div>
                                  <pre className="tool-call-code">{JSON.stringify(input, null, 2)}</pre>
                                </div>
                              )}
                              {output && (
                                <div className="tool-call-section">
                                  <div className="tool-call-label">RESULT</div>
                                  <pre className="tool-call-code">{JSON.stringify(output, null, 2)}</pre>
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      );
                    }

                    // Handle regular tool calls (for backward compatibility)
                    if (
                      part.type === 'tool-invocation' ||
                      (part.type.startsWith('tool-') && 'state' in part && 'input' in part)
                    ) {
                      const toolPart = part as {
                        toolCallId: string;
                        toolName: string;
                        input: unknown;
                        result?: unknown;
                        state?: string;
                        output?: unknown;
                        errorText?: string;
                      };
                      const toolId = `${message.id}-tool-${index}`;
                      const isExpanded = expandedTools.has(toolId);
                      const toggleTool = () => {
                        setExpandedTools((prev) => {
                          const next = new Set(prev);
                          if (next.has(toolId)) {
                            next.delete(toolId);
                          } else {
                            next.add(toolId);
                          }

                          return next;
                        });
                      };

                      // Extract SQL query from tool
                      const getSqlQuery = () => {
                        if (toolPart.input && typeof toolPart.input === 'object' && 'query' in toolPart.input) {
                          return toolPart.input.query as string;
                        }

                        return null;
                      };

                      const sqlQuery = getSqlQuery();

                      // Determine status badge
                      const getStatusInfo = () => {
                        if (toolPart.errorText) return { label: 'Error', className: 'status-error' };
                        if (toolPart.output) return { label: 'Completed', className: 'status-completed' };
                        if (toolPart.state === 'input-available')
                          return { label: 'Running', className: 'status-running' };
                        return { label: 'Pending', className: 'status-pending' };
                      };

                      const statusInfo = getStatusInfo();

                      return (
                        <div key={index} className="tool-call">
                          <button type="button" className="tool-call-header" onClick={toggleTool}>
                            <div className="tool-call-title">
                              <svg
                                className="tool-icon"
                                width="14"
                                height="14"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              >
                                <circle cx="12" cy="12" r="3"></circle>
                                <path d="M12 1v6m0 6v6m9-9h-6m-6 0H3m15.364 6.364l-4.243-4.243m-4.242 0l-4.243 4.243m0-8.485l4.243 4.243m4.242 0l4.243-4.243"></path>
                              </svg>
                              <span className="tool-name">{toolPart.toolName || 'Tool Call'}</span>
                              <span className={`tool-status ${statusInfo.className}`}>{statusInfo.label}</span>
                            </div>
                          </button>

                          {/* Always show SQL query for queryRedshift tool */}
                          {sqlQuery && (
                            <div
                              className="sql-preview"
                              style={{
                                marginTop: '8px',
                                padding: '12px',
                                backgroundColor: '#f8f9fa',
                                borderRadius: '4px',
                                border: '1px solid #e0e0e0',
                              }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  marginBottom: '8px',
                                }}
                              >
                                <span
                                  style={{
                                    fontSize: '11px',
                                    fontWeight: 600,
                                    color: '#666',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.5px',
                                  }}
                                >
                                  SQL Query
                                </span>
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    navigator.clipboard.writeText(sqlQuery);
                                    const toolId = `${message.id}-tool-${index}`;
                                    setCopiedToolId(toolId);
                                    setTimeout(() => setCopiedToolId(null), 2000);
                                  }}
                                  style={{
                                    padding: '4px 8px',
                                    fontSize: '11px',
                                    backgroundColor:
                                      copiedToolId === `${message.id}-tool-${index}` ? '#e8f5e9' : '#fff',
                                    border:
                                      copiedToolId === `${message.id}-tool-${index}`
                                        ? '1px solid #4caf50'
                                        : '1px solid #d0d0d0',
                                    borderRadius: '3px',
                                    cursor: 'pointer',
                                    color: copiedToolId === `${message.id}-tool-${index}` ? '#2e7d32' : '#333',
                                    transition: 'all 0.2s ease',
                                  }}
                                  type="button"
                                >
                                  {copiedToolId === `${message.id}-tool-${index}` ? '✓ Copied!' : '📋 Copy'}
                                </button>
                              </div>
                              <pre
                                style={{
                                  margin: 0,
                                  padding: '8px',
                                  backgroundColor: '#fff',
                                  borderRadius: '3px',
                                  fontSize: '13px',
                                  lineHeight: '1.5',
                                  overflowX: 'auto',
                                  fontFamily: 'Monaco, Consolas, "Courier New", monospace',
                                  color: '#2d3748',
                                }}
                              >
                                {sqlQuery}
                              </pre>
                            </div>
                          )}

                          {isExpanded && (
                            <div className="tool-call-content">
                              {toolPart.input && Object.keys(toolPart.input).length > 0 && (
                                <div className="tool-call-section">
                                  <div className="tool-call-label">PARAMETERS</div>
                                  <pre className="tool-call-code">{JSON.stringify(toolPart.input, null, 2)}</pre>
                                </div>
                              )}
                              {toolPart.output && (
                                <div className="tool-call-section">
                                  <div className="tool-call-label">RESULT</div>
                                  <pre className="tool-call-code">{JSON.stringify(toolPart.output, null, 2)}</pre>
                                </div>
                              )}
                              {toolPart.errorText && (
                                <div className="tool-call-section tool-call-error">
                                  <div className="tool-call-label">ERROR</div>
                                  <div className="tool-call-code">{toolPart.errorText}</div>
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      );
                    }

                    return null;
                  },
                )}
              </div>
            </div>
          ))}
          {status === 'submitted' && messages[messages.length - 1]?.role === 'user' && (
            <div className="message message-assistant">
              <div className="message-role">Assistant</div>
              <div className="message-content">
                <div className="typing-indicator">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>
            </div>
          )}
          {error && (
            <div className="message message-assistant">
              <div className="message-role">Error</div>
              <div className="message-content">
                <div
                  style={{
                    backgroundColor: '#fee',
                    border: '1px solid #fcc',
                    borderRadius: '4px',
                    padding: '12px',
                    color: '#c00',
                  }}
                >
                  <strong>⚠️ Error:</strong> {error.message || 'An error occurred while processing your request.'}
                  {error.message?.includes('Input is too long') && (
                    <div style={{ marginTop: '8px', fontSize: '14px', color: '#666' }}>
                      💡 Try asking a simpler question or starting a new conversation.
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>

        <form onSubmit={handleSubmit} className="chat-input-form">
          <input
            type="text"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="Ask a question about your Redshift data..."
            className="chat-input"
            disabled={status !== 'ready' && !error}
          />
          <button type="submit" className="chat-submit" disabled={(status !== 'ready' && !error) || !input.trim()}>
            Send
          </button>
        </form>
      </div>
    </>
  );
};
